<div class="margin-top-lg">
	<mat-card-title class="h5">
		Enrollments
		<help-text-btn class="align-help-text-btn" [helpTextId]="'Child_Enrollments_Overview'"></help-text-btn>
		<mat-icon *ngIf="isLoading">
			<mat-spinner diameter="18"></mat-spinner>
		</mat-icon>
		<span class="align-btn">
			<button mat-raised-button
				*ngIf="!isLoading && editing && !missingCOE && featurePermissions['Create Student School Enrollments']"
				color="primary" (click)="editDialog()">Add new school
				enrollment</button>
		</span>
	</mat-card-title>
	<mat-divider> </mat-divider>

	<mat-card-content class="margin-top-lg"
		*ngIf="!isLoading && (!schoolEnrollments || schoolEnrollments.length === 0)">
		<h3>This child does not have any school enrollments.</h3>
	</mat-card-content>

	<div *ngIf="!isLoading && regions && regions.length > 0">

		<div *ngFor="let region of regions; let i = index" class="margin-top-md">
			<h3>Region {{region.CODE}} - {{region.NAME}}</h3>

			<div class="table-responsive">
				<mat-table [dataSource]="region.tableDataSource" class="mat-elevation-z1" matSort>
					<ng-container matColumnDef="EDIT">
						<mat-header-cell *matHeaderCellDef> </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div
								*ngIf="!editing ? true : (hasAdminRole ? false : userRegion.ID !== region.ID || !(element.SCHOOL_DISTRICT?.ID ? userSchoolDistricts[element.SCHOOL_DISTRICT?.ID.toString()] : false))">
								<button mat-icon-button color="primary" (click)="viewDialog(element)" matTooltip="View">
									<mat-icon>visibility</mat-icon>
								</button>
							</div>

							<div
								*ngIf="editing && (hasAdminRole ? true : userRegion.ID === region.ID && (element.SCHOOL_DISTRICT?.ID ? userSchoolDistricts[element.SCHOOL_DISTRICT?.ID.toString()] : false))">
								<button *ngIf="featurePermissions['Edit Student School Enrollments']" mat-icon-button
									color="primary" (click)="editDialog(element)" matTooltip="Edit">
									<mat-icon>edit</mat-icon>
								</button>

								<delete-child-enrollment-confirm-btn
									*ngIf="featurePermissions['Delete Student School Enrollments']"
									[schoolEnrollments]="[element]"
									(onConfirm)="deletedSchoolEnrollment($event)"></delete-child-enrollment-confirm-btn>
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS_ASL.SCHOOL_YEAR">
						<mat-header-cell *matHeaderCellDef mat-sort-header> School Year </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.SCHOOL_ENROLLMENT_DETAILS_ASL.SCHOOL_YEAR}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS_ASL.ENROLLMENT_TYPE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Type </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.SCHOOL_ENROLLMENT_DETAILS_ASL.ENROLLMENT_TYPE}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS_ASL.GRADE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Grade </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.SCHOOL_ENROLLMENT_DETAILS_ASL.GRADE}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS_ASL.TRACK">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Track </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.SCHOOL_ENROLLMENT_DETAILS_ASL.TRACK}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="COUNTy.COUNTY_CODE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> County </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div [matTooltip]="element.COUNTy.COUNTY_NAME" [matTooltipPosition]="'above'">
								{{element.COUNTy.COUNTY_CODE}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SCHOOL_DISTRICT.DISTRICTS">
						<mat-header-cell *matHeaderCellDef mat-sort-header> District </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.SCHOOL_DISTRICT.DISTRICTS | titlecase}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SCHOOL.NAME">
						<mat-header-cell *matHeaderCellDef mat-sort-header> School </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.SCHOOL.NAME | titlecase}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS_ASL.ENROLLMENT_DATE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Enroll Date </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.SCHOOL_ENROLLMENT_DETAILS_ASL.ENROLLMENT_DATE | cleanDate | simpleDate}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS_ASL.WITHDRAWAL_DATE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Withdrawal Date </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.SCHOOL_ENROLLMENT_DETAILS_ASL.WITHDRAWAL_DATE | cleanDate | simpleDate}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS_ASL.DEPARTURE_DATE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Departure Date </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.SCHOOL_ENROLLMENT_DETAILS_ASL.DEPARTURE_DATE | cleanDate | simpleDate}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS_ASL.PFS">
						<mat-header-cell *matHeaderCellDef mat-sort-header> PFS </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								{{element.SCHOOL_ENROLLMENT_DETAILS_ASL.PFS ? element.SCHOOL_ENROLLMENT_DETAILS_ASL.PFS
								:
								'N'}}
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SOURCE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Source </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div [matTooltip]="getCreatedOn(element.CREATED_DATE)" [matTooltipPosition]="'above'">
								{{element.SOURCE}} /
								@if (element.COE_SCHOOL_ENROLLMENTS.length > 0) {
								<a [routerLink]="['/coe/dynamic/', element.COE_SCHOOL_ENROLLMENTS[0].CO.ID]"
									target="_blank" class="link-minified"
									[ngClass]="{'deletedEnrollment': (element.SCHOOL_ENROLLMENT_DETAILS_ASL.SCHOOL_YEAR && (element.SCHOOL_ENROLLMENT_DETAILS_ASL.VERIFIED == 'False' || element.SCHOOL_ENROLLMENT_DETAILS_ASL.VERIFIED == 'false'))}">
									{{element.COE_SCHOOL_ENROLLMENTS[0].CO.COE_NUMBER}}
								</a>
								}
								@else {
								<span>{{element.CREATED_BY}}</span>
								}
							</div>
						</mat-cell>
					</ng-container>

					<mat-header-row *matHeaderRowDef="schoolEnrollmentDisplayedColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: schoolEnrollmentDisplayedColumns;"
						[ngClass]="{'strikethrough': (row.SCHOOL_ENROLLMENT_DETAILS_ASL.SCHOOL_YEAR && (row.SCHOOL_ENROLLMENT_DETAILS_ASL.VERIFIED == 'False' || row.SCHOOL_ENROLLMENT_DETAILS_ASL.VERIFIED == 'false'))}">
					</mat-row>
				</mat-table>

			</div>
		</div>

	</div>

	<mat-card-title class="margin-top-lg h5"
		*ngIf="!isLoading && provisionalSchoolEnrollments && provisionalSchoolEnrollments.length > 0">
		Provisional School Enrollments
	</mat-card-title>
	<mat-divider> </mat-divider>

	<div *ngIf="!isLoading && provisionalSchoolEnrollments && provisionalSchoolEnrollments.length > 0"
		class="margin-top-md table-responsive">
		<mat-table [dataSource]="provisionalSchoolEnrollmentTableDataSource" class="mat-elevation-z1" matSort>

			<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS_ASL.SCHOOL_YEAR">
				<mat-header-cell *matHeaderCellDef mat-sort-header> School Year </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div>
						{{element.SCHOOL_ENROLLMENT_DETAILS_ASL.SCHOOL_YEAR}}
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS_ASL.ENROLLMENT_TYPE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Type </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div>
						{{element.SCHOOL_ENROLLMENT_DETAILS_ASL.ENROLLMENT_TYPE}}
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS_ASL.GRADE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Grade </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div>
						{{element.SCHOOL_ENROLLMENT_DETAILS_ASL.GRADE}}
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS_ASL.TRACK">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Track </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div>
						{{element.SCHOOL_ENROLLMENT_DETAILS_ASL.TRACK}}
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="PARTY_RELATIONSHIPS.PARTY_ROLES.PARTy.PROVISIONAL_SCHOOLS[0].DISTRICT">
				<mat-header-cell *matHeaderCellDef mat-sort-header> District </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div>
						{{element.PARTY_RELATIONSHIPS.PARTY_ROLES.PARTy.PROVISIONAL_SCHOOLS[0].DISTRICT | titlecase}}
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="PARTY_RELATIONSHIPS.PARTY_ROLES.PARTy.PROVISIONAL_SCHOOLS[0].SCHOOL_NAME">
				<mat-header-cell *matHeaderCellDef mat-sort-header> School </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div>
						{{element.PARTY_RELATIONSHIPS.PARTY_ROLES.PARTy.PROVISIONAL_SCHOOLS[0].SCHOOL_NAME | titlecase}}
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS_ASL.ENROLLMENT_DATE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Enroll Date </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div>
						{{element.SCHOOL_ENROLLMENT_DETAILS_ASL.ENROLLMENT_DATE | cleanDate | simpleDate}}
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS_ASL.WITHDRAWAL_DATE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Withdrawal Date </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div>
						{{element.SCHOOL_ENROLLMENT_DETAILS_ASL.WITHDRAWAL_DATE | cleanDate | simpleDate}}
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS_ASL.DEPARTURE_DATE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Departure Date </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div>
						{{element.SCHOOL_ENROLLMENT_DETAILS_ASL.DEPARTURE_DATE | cleanDate | simpleDate}}
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS_ASL.PFS">
				<mat-header-cell *matHeaderCellDef mat-sort-header> PFS </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div>
						{{element.SCHOOL_ENROLLMENT_DETAILS_ASL.PFS ? element.SCHOOL_ENROLLMENT_DETAILS_ASL.PFS : 'N'}}
					</div>
				</mat-cell>
			</ng-container>

			<mat-header-row *matHeaderRowDef="provisionalSchoolEnrollmentDisplayedColumns"></mat-header-row>
			<mat-row *matRowDef="let row; columns: provisionalSchoolEnrollmentDisplayedColumns;"></mat-row>
		</mat-table>

	</div>
</div>